<template>
  <table
    id="kye-year-table3"
    @mousemove="handleMouseEnter"
    @click="handleYearTableClick"
    class="el-year-table">
    <tbody>
      <tr>
        <td class="available" :class="getCellStyle(startYear + 0)">
          <a class="cell">{{ startYear }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 1)">
          <a class="cell">{{ startYear + 1 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 2)">
          <a class="cell">{{ startYear + 2 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 3)">
          <a class="cell">{{ startYear + 3 }}</a>
        </td>
      </tr>
      <tr>
        <td class="available" :class="getCellStyle(startYear + 4)">
          <a class="cell">{{ startYear + 4 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 5)">
          <a class="cell">{{ startYear + 5 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 6)">
          <a class="cell">{{ startYear + 6 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 7)">
          <a class="cell">{{ startYear + 7 }}</a>
        </td>
      </tr>
      <tr>
        <td class="available" :class="getCellStyle(startYear + 8)">
          <a class="cell">{{ startYear + 8 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 9)">
          <a class="cell">{{ startYear + 9 }}</a>
        </td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<script type="text/babel">
import { hasClass } from 'element-ui/lib/utils/dom'
import { isDate, range, nextDate, getDayCountOfYear } from '../util'
import { arrayFindIndex, coerceTruthyValueToArray } from 'element-ui/lib/utils/util'

const datesInYear = year => {
  const numOfDays = getDayCountOfYear(year)
  const firstDay = new Date(year, 0, 1)
  return range(numOfDays).map(n => nextDate(firstDay, n))
}

export default {
  props: {
    disabledDate: {},
    value: {},
    defaultValue: {
      validator(val) {
        // null or valid Date Object
        return val === null || (val instanceof Date && isDate(val))
      }
    },
    date: {}
  },

  computed: {
    startYear() {
      return Math.floor(this.date.getFullYear() / 10) * 10
    }
  },

  methods: {
    getCellStyle(year) {
      const style = {}
      const today = new Date()

      style.disabled = typeof this.disabledDate === 'function' ? datesInYear(year).every(this.disabledDate) : false
      style.current = arrayFindIndex(coerceTruthyValueToArray(this.value), date => date.getFullYear() === year) >= 0
      style.today = today.getFullYear() === year
      style.default = this.defaultValue && this.defaultValue.getFullYear() === year

      return style
    },

    handleYearTableClick(event) {
      const target = event.target
      if (target.tagName === 'A') {
        if (hasClass(target.parentNode, 'disabled')) return
        const year = target.textContent || target.innerText
        this.$emit('pick', Number(year))
      }
    },

    handleMouseEnter(event) {
      let target = event.target
      if (target.tagName === 'A') {
        const year = target.textContent || target.innerText
        const params = {
          newDate: year,
          event
        }
        this.$parent.handleDateMouseEnter && this.$parent.handleDateMouseEnter(params)
      }
    },
  }
}
</script>
<style lang="scss">
#kye-year-table3.el-year-table td.current:not(.disabled) .cell {
  color: #ffffff;
  border-radius: 4px;
  /* 渐变色/蓝色/常规 */
  border: none !important;
  background: linear-gradient(90deg, #8b60f0 0%, #8b60f0 100%);
}
#kye-year-table3.el-year-table td .cell:hover {
  color: #8b60f0;
  /* 圆角/4px */
  border-radius: 4px;
  /* C06-Light gray(灰色交互反馈色)/04-浅色背景悬停色(4%) */
  background: rgba(28, 30, 35, 0.04);
}
#kye-year-table3 .today .cell {
  /* 圆角/4px */
  border-radius: 4px;
  box-sizing: border-box;
  /* ☆C01-Cobalt blue(品牌蓝)/☆05-#8b60f0✅-常规 */
  /* 样式描述：默认 */
  border: 1px solid #8b60f0;
  color: #8b60f0;
}
#kye-year-table3.el-year-table td.disabled .cell {
  background-color: #f5f7fa;
  cursor: not-allowed;
  color: #c0c4cc;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker3/src/basic/year-table.vue